import React from 'react';
import PropTypes from 'prop-types';
import { Button, Table } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import connect from 'react-redux/es/connect/connect';

const ProjectsTable = props => {
  let projetsArray = props.projects;
  if (props.projects.data) {
    projetsArray = props.projects.data;
  }
  const projectRows = projetsArray.map(project => {
    const rowClassNames = classnames({
      'projects-list__body--locked': project.template_locked
    });

    return (
      <Table.Row key={project.id} className={rowClassNames}>
        <Table.Cell width={12}>
          {props.path === '/analysis' ? (
            <a
              href="#"
              className="projetc-analysis-link"
              onClick={e => {
                e.preventDefault();
                props.editHandler(project.id);
              }}
            >
              {project.name}
            </a>
          ) : (
            <Link className="projetc-analysis-link" to={`/projects/${project.id}`}>
              {project.name}
            </Link>
          )}
        </Table.Cell>

        <Table.Cell width={2}>
          {project.template_locked ? (
            <span className="locked">
              <i className="fas fa-lock"> </i> Locked
            </span>
          ) : (
            <span className="unlock">
              <i className="fas fa-lock-open"> </i> Unlocked
            </span>
          )}
        </Table.Cell>
        <Table.Cell width={1}>
          {project.template_locked ? (
            <Link
              className="edit-project"
              to={{ pathname: `/analysis/${project.id}`, state: { fromApp: true } }}
            >
              <i className="fas fa-share"> </i>
            </Link>
          ) : (
            <span className="edit-project disabled icon-mail-forward" />
          )}
        </Table.Cell>
        <Table.Cell width={1}>
          <Button
            className="transparent delete-project"
            onClick={e => {
              props.deleteHandler(project.id, project.name);
            }}
          >
            <i className="trash icon" />
          </Button>
        </Table.Cell>
      </Table.Row>
    );
  });

  return (
    <Table celled className="projects-list">
      <Table.Header className="projects-list__header">
        <Table.Row>
          <Table.HeaderCell>Projects</Table.HeaderCell>
          <Table.HeaderCell>Experimental Design</Table.HeaderCell>
          <Table.HeaderCell>Analysis</Table.HeaderCell>
          <Table.HeaderCell>Delete</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body className="projects-list__body">{projectRows}</Table.Body>
    </Table>
  );
};

ProjectsTable.propTypes = {
  projects: PropTypes.array,
  deleteHandler: PropTypes.func
};

ProjectsTable.defaultProps = {
  projects: [],
  deleteHandler: () => {},
  editHandler: id => {}
};

export default connect(state => ({
  projects: state.projects.list.data
}))(ProjectsTable);



// WEBPACK FOOTER //
// ./src/scenes/projects/components/ProjectsTable.js